import { Navigate, useParams } from "react-router-dom";

import LoginLayout from "../../layouts/login.layout";
import { SignUpSideBanner } from "../../utils/constant/signup.constant";
import SignUpForm from "../../components/Form/SignUp.forms";
import { SignUpFormConfig } from "../../utils/constant/formConfig.constant";
import { userTypeTypeNameToKeyMap } from "@/utils/constant/login.constant";

const SignUpPage = () => {
  const { type } = useParams<{ type: keyof typeof userTypeTypeNameToKeyMap }>();

  if (!type || !(type in userTypeTypeNameToKeyMap) || type !== "organization") {
    // redirect to home page
    return <Navigate to="/" replace />;
  }
  const userTypeKey = userTypeTypeNameToKeyMap[type] as keyof typeof SignUpSideBanner;

  return (
    <LoginLayout sideBanner={SignUpSideBanner[userTypeKey]}>
      <div className=" flex flex-col items-center w-full md:max-w-[700px]">
        <div className="mt-12 h-full w-full md:w-[400px]">
          <SignUpForm SignUpFormConfig={SignUpFormConfig[userTypeKey]} signupType={userTypeKey} />
        </div>
      </div>
    </LoginLayout>
  );
};

export default SignUpPage;
